
































import {Component, Prop, Provide} from 'vue-property-decorator';
import Vue from 'vue';
import YesNoNaInput from '@/Components/Input/YesNoNaInput.vue';

@Component({
    components: {YesNoNaInput},
})
export default class YesNoNaDetailsInput extends Vue {
    static COMPONENT_NAME = 'yes-no-na-details-input'

    @Prop({type: String, required: true}) label!: string
    @Prop({type: String, required: true}) name!: string
    @Prop({type: String, default: null}) detailsName!: string
    @Prop({type: Boolean, default: true}) showOnYes!: boolean
    @Prop({type: String, default: 'If yes, please explain'}) detailsLabel!: string
    @Prop({type: String, default: 'textarea'}) detailsType!: string
    @Prop({type: Array, default: () => ['required']}) detailsValidation!: string[]
    @Prop({type: Object, default: () => ({
        required: 'Please provide details'
    })}) detailsValidationMessages!: Record<string, string>

    @Provide() showDetails: boolean = false
    @Provide() internalDetailsValue: string = ''

    get resolvedDetailsName(): string {
        return this.detailsName || `${this.name}__details`;
    }

    handleInput(value: string) {
        this.showDetails = this.showOnYes ? (value === YesNoNaInput.YES) : (value === YesNoNaInput.NO);
    }

}

